<template>
  <div id="OnboardingVP1" class="" style="width: -webkit-fill-available;">
    <div class="layout-content container-fluid">
      <HeadingUserVP1 />
      <div class="row">
        <div class="col-12">
          <toaster-informative :show="getterTicket.show && can('3')" :type="'notification'" :hide-circle-to-icon="true"
            :contains-link="true" :link-path="'/solicitudes'" :message="getterTicket.message" />

        </div>
        <b-col cols="12" class="ml-5 mt-5">
          <p class="text-hi">
              Hola! {{ gerRoleOfCurrentUser.toLowerCase() }}
          </p>
        </b-col>
        <div class="col-xs-12 col-md-8 col-lg-8 mx-auto">
          <div v-if="loadingOn" id="loader"></div>
          <div v-else class="cont-carousel carousel_VP1 mt-5">
            <b-carousel id="my-carousel"
                        :interval="4000"
                        img-width="1024"
                        img-height="580"
                        background="#FFFFFF"
                        style="text-shadow: #000000"
                        @sliding-start="onSlideStart"
                        @sliding-end="onSlideEnd"
                        fade>
              <b-carousel-slide v-for="({ image, title, text, link }, index) in onboardingData"
                                :key="index">
                  <template v-slot:img>
                      <img :src="`${serverPath}/${image}`"
                           :alt="'image'.concat(index)"
                           width="450"
                           height="400"
                           class="img-left" />
                  </template>
                  <template v-slot:default>
                      <div class="text-right">
                        <h3 class="carousel-title" v-html="formattedTextLineBreak(title)" />
                        <p class="carousel-description">{{ text }}</p>
                        <template v-if="link">
                          <router-link :to="{ path: link }"
                                       class="carousel-btn mt-3">
                            Empezar
                          </router-link>
                        </template>
                      </div>
                  </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
        <coming-soon v-if="validModule('health-tracker')" class="col-10 mx-auto" />
        <!-- .col -->
      </div>
      <!-- .row -->
    </div>
    <!-- .layout-content -->
    <!-- modal -->
    <b-modal hide-footer :visible="getterTicket.show && can('3')" no-close-on-esc no-close-on-backdrop centered>
      <template #modal-title />
      <div class="d-block text-center">
        <div class="col-12 pb-3">
          <i class="icon-notification fa-9x" style="color: #E06100; font-size: 60px;" />
        </div>
        <toaster-informative :show="true" :type="'notification'" :hide-circle-to-icon="true"
          :message="getterTicket.message" />
        <a class="h5" style="cursor: pointer; color: #000000;" @click.prevent="$router.push('/solicitudes')">
          <u> Haz click acá para gestionar tus solicitudes pendientes. </u>
        </a>
      </div>
    </b-modal>
  </div>

</template>


<script>

import HeadingUserVP1 from "@/components/user/HeadingUserVP1.vue";
import {
  mapActions,
  mapState,
  mapGetters
} from "vuex"
import ComingSoon from "@/components/healthTracker/comingSoon.vue"
import serverConfig from "@/services/config";

export default {
  name: 'onboardingVP1',
  components: {

    HeadingUserVP1,
    ComingSoon,
    toasterInformative: () => import('@/components/common/toasters/Informative.vue')
    // modalMixed: () => import('@/components/common/Modals/ModalMixed.vue')
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      slide: 0,
      sliding: null,
      onboardingData: []
    };
  },
  created() {
    this.actUser()
  },
  async beforeMount() {
    if (
        this.canWithCode('aprobador')
    ) {
      await this.getCount()
    }

    await this.actGetOnboarding().then(() => {
      this.onboardingData = this.onboarding.data;
    })
      .catch((response) => {
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message = "No se pudo conectar al servicio: error: " + response;
      });
    await this.actUserLocalStorage()
    this.modalNPS();
  },

  computed: {
    ...mapState("modCore", [
      "user",
      "onboarding",
      "loadingOn"
    ]),
    ...mapGetters('modLicenseTickets', [
      'getterTicket'
    ])
  },

  methods: {
    ...mapActions('modCore', [
      'actGetOnboarding',
      'actUser',
      'actUserLocalStorage'
    ]),
    ...mapActions('modLicenseTickets', [
      'getCount'
    ]),

    onSlideStart() {
      this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    },
    modalNPS() {
      if (this.validateNPS(this.user)) {
        window.test(this.user.sharp_id);
      }
    },

    validateNPS(user) {
      if (
        typeof user === 'object' &&
        user.sharp_id !== null &&
        user.sharp_id.length < 9
      )
        return true;

      return false;
    }
  },
};
</script>
  

<style lang="scss" scoped>
  /** Carousel */
  #OnboardingVP1 {
    .carousel-btn {
      float: left;
      width: auto;
      height: auto;
      top: 480px;
      left: 751px;
      padding: 6px 43px 6px 43px;
      border-radius: 25px;
      color: #FFFFFF;
      background-color: #1C3A4E;
      border-color: transparent;
      white-space: nowrap; /* Evita el corte de palabras */
      overflow: hidden; /* Oculta cualquier texto que se desborde del botón */
      text-overflow: ellipsis;
    }
    .carousel-description {
      font-family: 'Open Sans',serif;
      font-size: 20px;
      font-weight: 600;
      line-height: 27px;
      letter-spacing: 0;
      text-align: justify;
    }

    .carousel-title {
      font-family: 'Poppins', serif;
      font-size: 40px;
      font-weight: 700;
      line-height: 60px;
      letter-spacing: 0;
      text-align: justify;
    }

    .img-left {
      float: left;
      max-width: 50%;
      margin-right: 20px;
    }
    .text-right {
      color: #454545;
    }

    .text-hi {
      color: #1C3A4E;
      font-family: 'Poppins', serif;
      font-size: 32px;
      font-weight: 500;
      line-height: 48px;
      letter-spacing: 0;
      text-align: left;
    }

    .p2 {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #1C3A4E;
      padding-left: 5%;
      text-align: justify;
    }
  
    #loader {
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 1;
      width: 150px;
      height: 150px;
      margin: 150px 0 0 -75px;
      border: 16px solid #f3f3f3;
      border-radius: 50%;
      border-top: 16px solid #3498db;
      width: 120px;
      height: 120px;
      -webkit-animation: spin 2s linear infinite;
      animation: spin 2s linear infinite;
    }
  
    @-webkit-keyframes spin {
      0% { -webkit-transform: rotate(0deg); }
      100% { -webkit-transform: rotate(360deg); }
    }
  
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  
    /* Add animation to "page content" */
    .animate-bottom {
      position: relative;
      -webkit-animation-name: animatebottom;
      -webkit-animation-duration: 1s;
      animation-name: animatebottom;
      animation-duration: 1s
    }
  
    @-webkit-keyframes animatebottom {
      from { bottom:-100px; opacity:0 } 
      to { bottom:0px; opacity:1 }
    }
  
    @keyframes animatebottom { 
      from{ bottom:-100px; opacity:0 } 
      to{ bottom:0; opacity:1 }
    }
  
    #myDiv {
      display: none;
      text-align: center;
    }


  }


   
 
  </style>
  <style lang="scss" >
  

  .cont-carousel.carousel_VP1{
      /*height: calc(100vh - 70px);
      padding-top: 50px;
      margin-bottom: 70px;
  
      @media (min-width: 768px) {
        padding-top: calc(50% - 300px);
      }
  
      @media (min-width: 992px) {
        padding-top: calc(50% - 150px);
      }
  
      @media (min-width: 1200px) {
        padding-top: calc(50% - 300px);
      }*/
      .carousel-caption {
        position: initial;
        right: 3%;
        bottom: auto;
      }
  
      .carousel-control-next-icon ,
      .carousel-control-prev-icon,
      .carousel-indicators {
        filter: invert(1) !important;
      }

    }

  </style>
